<div class="container-fluid gx-5">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'house']"></fa-icon> Home
        </h3>
      </div>
      <div class="mt-4 p-5 bg-primary text-white rounded">
        @if(isLoggedIn) {
        <p>
          Currently logged in as {{me?.fullName}} ({{me?.email}}).
        </p>
        } @else {
        <p>
          Currently logged out.
        </p>
        }
        <!-- <a routerLink="/test1">Test 1</a>
    <br>
    <a routerLink="/test2">Test 2</a>
    <br>
    <a routerLink="/testgrid">Test Grid</a> -->
      </div>
    </div>
  </div>
</div>
